export default __webpack_public_path__ + "static/media/002-skateboard.78e06a09.svg";